<template>
    <div class="terms">
        <!-- <v-container fluid>
            <v-row>
                <v-col>
                    <v-img :src="'https://artlesscms.actstudio.xyz/'+terms.cover.path" width="100%"></v-img>
                </v-col>
            </v-row>
        </v-container> -->

        <v-container>
            <v-row>
                <v-col>
                    <div class="terms-container">
                        <div>
                            <!-- <h2 style="text-align: justify;">Terms Of Service</h2> -->

                            <div v-html="terms.text">

                            </div>

                            <!-- <p style="text-align: justify;">Welcome to the ARTLESS Corporation web site. ARTLESS is a manufacturer of high quality home accessories. These terms of service govern your access to and use of the site. Please take the time to review these terms and conditions carefully. Your use of our site constitutes your agreement to follow these rules and to be bound by them.</p>
                            <p style="text-align: justify;">These terms of service may be updated or amended at any time without notice, so we encourage you to check back regularly. Your continued use of our site is your consent to any and all updates and amendments.<br /><br /></p>
                            <h2 style="text-align: justify;">Use Of Web Site</h2>
                            <p style="text-align: justify;">All of the content that you see on our site, including all visuals, designs and text, is the exclusive property of ARTLESS and is subject to all applicable trademark, service mark, trade dress, copyright and other intellectual property rights. The entire content of the ARTLESS site is copyrighted as a collective work under U.S. Copyright laws. ARTLESS hereby grants you a limited license to access and use of the content on our site solely for your own personal, noncommercial use.</p>
                            <p style="text-align: justify;">You are strictly prohibited from accessing or using the ARTLESS website for any illegal or unauthorized purpose. Harassment in any manner or form through our site, including via email or by obscene or abusive language, will not be tolerated.</p>
                            <p style="text-align: justify;">We welcome your respectful comments and feedback; however, any comments, feedback, messages, ideas, suggestions or other communication sent to our site shall be and remain the exclusive property of ARTLESS. Furthermore, ARTLESS shall be under no obligation to hold your comments in confidence, compensate you for any communications, or to respond.<br /><br /></p>
                            <h2 style="text-align: justify;">Manufacturing Variations</h2>
                            <p style="text-align: justify;">We have done our best to accurately display our products on our site. Nonetheless, please be aware that each product is hand crafted and variations may occur. We believe such variations add to the beauty of our hand crafted product. Note that these variations are not considered manufacturing faults and as such will not be eligible for return. Colors, in particular, can vary depending on your monitor.<br /><br />
                            </p>
                            <h2 style="text-align: justify;">Warranty</h2>
                            <p style="text-align: justify;">ARTLESS offers a&nbsp;<a href="http://www.artlesscorporation.com/pages/warranty">limited lifetime warranty</a>&nbsp;on all of its products.<br /><br /></p>
                            <h2 style="text-align: justify;">Disclaimer</h2>
                            <p style="text-align: justify;">This site and all content available on this site are provided on an &ldquo;as is&rdquo; basis. No warranties, either express or implied, are made with respect to this site, including, without limitation, warranties of title or implied warranties of merchantability, non-infringement, or fitness for a particular purpose. By using this site acknowledge that your use is at your sole risk, and you agree to indemnify and hold ARTLESS (including its officers, directors, agents and employees) harmless from any claim or demand, along with any losses or damages of any sort resulting from any violation of these terms of service or any activity relating to your account. This indemnification shall remain in effect even if there is a subsequent modification or termination to the site.<br /><br /></p>
                            <h2 style="text-align: justify;">Site Errors</h2>
                            <p style="text-align: justify;">Despite our best efforts, our site may contain typographical errors or inaccuracies. Such errors may relate to product information, including pricing and availability. If this occurs, we shall have the right to terminate any orders involving pricing errors or inaccuracies. We apologize for any inconvenience.<br /><br /></p>
                            <h2 style="text-align: justify;">Privacy Policy</h2>
                            <p style="text-align: justify;">At ARTLESS we don&rsquo;t like sharing your information with anybody. We like doing furniture and that&rsquo;s what we do, so you don&rsquo;t have to worry about us.<br /><br /></p>
                            <h2 style="text-align: justify;">Pricing Policy</h2>
                            <p style="text-align: justify;">All prices displayed on this site are quoted in U.S. dollars.<br /><br /></p>
                            <h2 style="text-align: justify;">Questions</h2>
                            <p style="text-align: justify;">If you have any questions regarding our terms of service, please email us at <a href="mailto:info@artlesscorporation.com">info@artlesscorporation.com</a></p> -->
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>    
</template>

<script>
export default {
    data(){
        return{
            terms: {
                cover: []
            }
        }
    },
    beforeMount: function(){
        fetch('https://www.artlesscms.actstudio.xyz/api/singletons/get/teminos?token=a15be93e9cdb43ca2b3778c2077c26')
        .then(data => data.json())
        .then(data => this.terms = data);
    },
    mounted: function(){
        var breadcrumbs = [
            {
                text: 'Home',
                link: '/',
                isLink: true
            },
            {
                text: 'Terms of Service',
                link: '/terms',
                isLink: false
            }
        ];
        this.$emit("updateStatus", breadcrumbs);

        gtag('config', 'UA-26953667-1', {
        'page_title' : 'Terms',
        'page_path': '/terms'
        });
    }
}
</script>
